(function () {

    'use strict';

    function fsTooltip() {
        return {
            restrict: 'EA',
            link: function ($scope, $element) {
                var elements = $element[0].querySelectorAll('.fs-tooltip');

                angular.forEach(elements, function (element) {
                    angular.element(element).tooltip();
                });
            }
        }
    }

    module.exports = fsTooltip;

})();